import { useMutation, useQueryClient } from "@tanstack/react-query";

import { axiosInstanceNamek } from "@/service/Axios";
import { INamekError, NamekError } from "@/models";

import { ASSIGN_MATERIALS_KEYS as KEYS } from "./queryKeys";

type UpdateAssignMaterialsBody = {
  id: number;
  materialIds: number[];
};

const putUpdateAssignMaterials = (data: UpdateAssignMaterialsBody) => {
  return axiosInstanceNamek
    .put(`/v1/GreenCenters/${data.id}/materials`, { materialIds: data.materialIds })
    .then((response) => response.data)
    .catch((error) => {
      throw new NamekError(error.response?.data);
    });
};

export const useUpdateAssignMaterials = () => {
  const queryClient = useQueryClient();

  return useMutation<number, INamekError, UpdateAssignMaterialsBody>({
    mutationFn: (data: UpdateAssignMaterialsBody) => putUpdateAssignMaterials(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [KEYS.RECORDS] });
    },
  });
};
